<template>
  <div style="box-shadow: 0 0 0 0 !important" class="adminGraph">
    <v-row justify="center" class="mt-5 graphContent" style="margin: 0px">
      <DailyReportFilter @handleFilter="handleFilter" />
    </v-row>

    <div v-if="!getDataDone">
      <!-- Date Range Display -->
      <div v-if="reportData.startDate" class="mt-4 mb-4">
        <v-row>
          <v-col cols="12" md="6">
            <label class="font-weight-bolder h5">
              <span>التاريخ من</span>: {{ reportData.startDate }}
            </label>
          </v-col>
          <v-col cols="12" md="6">
            <label class="font-weight-bolder h5">
              <span>التاريخ الى</span>: {{ reportData.endDate }}
            </label>
          </v-col>
        </v-row>
      </div>

      <!-- Table View -->
      <table-component
        v-if="tableData.length > 0"
        itemKey="id"
        :headers="tableHeaders"
        :formBody="body"
        :pagination="pagination"
        :limit="$store.state.counterOfShow"
        :items="tableData"
        :loading="loading"
        v-model="page"
        style="margin-bottom: 30px"
      />

      <!-- Sources Legend -->
      <div v-if="reportData.sources && Object.keys(reportData.sources).length" class="mb-4">
        <div class="legend-container">
          <div 
            v-for="(source, key) in filteredSources" 
            :key="key"
            class="legend-item"
          >
            <div 
              class="legend-color" 
              :style="{ backgroundColor: source.color }"
            ></div>
            <div class="legend-info">
              <div class="legend-name">{{ source.name }}</div>
              <div class="legend-count">{{ source.total }}</div>
            </div>
          </div>
          <div class="legend-item total-item">
            <div class="legend-color color-total"></div>
            <div class="legend-info">
              <div class="legend-name font-weight-bold">المجموع الكلي</div>
              <div class="legend-count font-weight-bold">{{ reportData.grandTotal }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Chart Container -->
      <div v-if="reportData.chartUsers && reportData.chartUsers.length">
        <div id="chart-container" style="width:100%; height:600px;"></div>
      </div>

      <div v-if="!loading && reportData.chartUsers && reportData.chartUsers.length === 0 && tableData.length === 0" class="text-center mt-4">
        <p>لا يوجد نتائج</p>
      </div>
    </div>
    <div v-else class="loader">
      <img src="../../../../assets/Comp-2.gif" />
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import Highcharts from "highcharts";
import DailyReportFilter from "@/views/admin/Charts/DailyReportFilter.vue";
import TableComponent from "@/components/Base/TableComponent.vue";

export default {
  name: "DetailedRequestsSourceReport",
  components: {
    DailyReportFilter,
    TableComponent,
  },
  data() {
    return {
      loading: false,
      getDataDone: false,
      reportData: {},
      tableData: [],
      tableHeaders: [],
      page: 1,
      body: {},
      pagination: {},
    };
  },
  watch: {
    page(val) {
      this.getData(val, "loading");
    },
    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval !== oldvalue && !this.$store.state.admin_search_active) {
          this.getData(this.page, "loading");
        }
      },
    },
  },
  computed: {
    filteredSources() {
      if (!this.reportData.sources) return [];
      
      return Object.entries(this.reportData.sources)
        .filter(([key, source]) => source.total > 0)
        .map(([key, source]) => ({
          key,
          ...source
        }))
        .sort((a, b) => b.total - a.total);
    },
  },
  mounted() {
  },
  methods: {
    showPopup(type, message) {
      this.$store.commit("showPopup", { type, message });
    },
    handleFilter(filterData) {
      this.body = new FormData();
      
      const managerIds = filterData.managerId || [];
      const agentIds = filterData.agentId || [];

      let status_user = 1;
      if (filterData.status === 'الكل' || filterData.status === '2' || filterData.status === '') {
        status_user = 2;
      } else if (filterData.status === 'استشاري مؤرشف' || filterData.status === '0') {
        status_user = 0;
      } else if (filterData.status === 'استشاري قائم' || filterData.status === '1') {
        status_user = 1;
      }
      
      if (filterData.startDate) {
        this.body.append("start_date", filterData.startDate);
      }
      
      if (filterData.endDate) {
        this.body.append("end_date", filterData.endDate);
      }
      
      if (filterData.range) {
        this.body.append("range", filterData.range);
      }
      
      if (filterData.dayNumber) {
        this.body.append("range", filterData.dayNumber);
      }
      
      this.body.append("status_user", status_user);
      
      if (managerIds && managerIds.length > 0) {
        managerIds.forEach((item, index) => {
          const managerId = typeof item === 'object' && item !== null ? item.id : item;
          this.body.append(`manager_id[${index}]`, managerId);
        });
      }
      
      if (agentIds && agentIds.length > 0) {
        agentIds.forEach((item, index) => {
          const agentId = typeof item === 'object' && item !== null ? item.id : item;
          this.body.append(`adviser_id[${index}]`, agentId);
        });
      }

      this.getData(1, "getDataDone");
    },
    getData(page, loader) {
      if (loader === "getDataDone") {
        this.getDataDone = true;
      } else if (loader === "loading") {
        this.loading = true;
      }
      
      this.tableData = [];
      const url = `${this.$store.state.url}/employee/admin/detailed-requests-source-report?page=${page}&per_page=${this.$store.state.counterOfShow}`;

      Axios.post(url, this.body, { headers: this.request_headers() })
        .then((response) => {
          this.reportData = response.data.payload || {};
          this.tableData = response.data.payload.data || [];
          
          // Build table headers dynamically from sources - show ALL sources
          if (this.reportData.sources && Object.keys(this.reportData.sources).length > 0) {
            this.tableHeaders = [
              { text: "الإستشاري", value: "الإستشاري", align: "center", width: "170px" },
            ];
            
            // Add ALL source columns
            Object.values(this.reportData.sources).forEach(source => {
              this.tableHeaders.push({
                text: source.name,
                value: source.name,
                align: "center"
              });
            });
            
            // Add total column
            this.tableHeaders.push({
              text: "المجموع",
              value: "المجموع",
              align: "center"
            });
          }
          
          this.pagination = {
            limit: 3,
            count: response.data.payload.total_agents || 0,
          };
          
          // Render chart after a short delay to ensure DOM is ready
          setTimeout(() => {
            this.renderChart();
          }, 100);
        })
        .catch((error) => {
          console.error("Error loading report:", error);
          this.showPopup("error", "حدث خطأ أثناء تحميل التقرير");
        })
        .finally(() => {
          this.loading = false;
          this.getDataDone = false;
        });
    },
    renderChart() {
      if (!this.reportData.chartUsers || this.reportData.chartUsers.length === 0) {
        return;
      }

      if (!this.reportData.sources) {
        return;
      }

      // Destroy existing chart if it exists
      const existingChart = Highcharts.charts.find(chart => chart && chart.renderTo.id === 'chart-container');
      if (existingChart) {
        existingChart.destroy();
      }

      // Wait for DOM to be ready
      this.$nextTick(() => {
        const chartContainer = document.getElementById('chart-container');
        if (!chartContainer) {
          console.warn('Chart container not found');
          return;
        }

        const series = [];
        const sources = Object.entries(this.reportData.sources)
          .sort((a, b) => b[1].total - a[1].total); // Sort by total, but include all

        sources.forEach(([key, source]) => {
          series.push({
            name: source.name,
            data: source.data || [],
            color: source.color,
          });
        });

        Highcharts.chart('chart-container', {
        chart: {
          type: 'column'
        },
        title: {
          text: 'تقرير تفصيلي لمصادر الطلبات المستلمة'
        },
        xAxis: {
          categories: this.reportData.chartUsers,
        },
        yAxis: {
          min: 0,
          title: {
            text: 'عدد الطلبات'
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: (Highcharts.defaultOptions.title.style &&
                Highcharts.defaultOptions.title.style.color) || 'gray'
            }
          }
        },
        legend: {
          align: 'right',
          x: -30,
          verticalAlign: 'top',
          y: 25,
          floating: true,
          backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}<br/>المجموع: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: series
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.legend-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 15px;
  background-color: #f9f9f9;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  min-width: 180px;
  padding: 8px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.legend-item.total-item {
  background: #f0f0f0;
  border: 2px solid #333;
}

.legend-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  flex-shrink: 0;
}

.color-total {
  background: linear-gradient(45deg, #333 25%, #666 25%, #666 50%, #333 50%, #333 75%, #666 75%);
  background-size: 10px 10px;
}

.legend-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.legend-name {
  font-size: 14px;
  color: #333;
}

.legend-count {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.color-indicator {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  margin: 0 auto;
  border: 1px solid #ddd;
}

.v-input__control {
  min-height: 40px !important;
}

.label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}


</style>
